var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    {
      staticClass: "button-icon-x",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            fill: "transparent",
            stroke: "#fff",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }
        },
        [
          _c("path", { attrs: { d: "M1,1 l10,10" } }),
          _vm._v(" "),
          _c("path", { attrs: { d: "M1,11 l10,-10" } })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }